import React from 'react';
import { BeautifulMentionNode } from 'lexical-beautiful-mentions';

class QuestionColumnMentionNode extends BeautifulMentionNode {
  static getType() {
    return 'questionColumnMentionNode';
  }

  static clone(node) {
    return new QuestionColumnMentionNode(node.__trigger, node.__value, node.__data, node.__key);
  }

  static importJSON(serializedNode) {
    return new QuestionColumnMentionNode(
      serializedNode.trigger,
      serializedNode.value,
      serializedNode.data,
      serializedNode.key
    );
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'questionColumnMentionNode',
      trigger: this.__trigger,
      value: this.__value,
      data: this.__data
    };
  }

  decorate(editor, config) {
    const wrapped = super.decorate(editor, config);
    return React.cloneElement(wrapped, { trigger: null, ...wrapped.props });
  }
}

export { QuestionColumnMentionNode };
